export const NODE_RESULTS_REQUEST = "NODE_RESULTS_REQUEST";
export const NODE_RESULTS_SUCCESS = "NODE_RESULTS_SUCCESS";
export const NODE_RESULTS_FAILURE = "NODE_RESULTS_FAILURE";
